import React, { useState } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { Collection } from '@components/common';
import './MyBorrowingsPage.scss';

export const MyBorrowingsPage = () => {
    const { t } = useTranslation();

    return (
        <div className="my-borrowings-page">
            <Collection
                modelName="borrowings"
                // Use the mine endpoint to get current user's borrowings
                endpoint="getMine"
                sortFields={[
                    { key: 'borrowed_at', label: t('borrowing.borrowed_date') },
                    { key: 'expected_return_at', label: t('borrowing.expected_return') },
                    { key: 'returned_at', label: t('borrowing.returned_date') }
                ]}
                displayOptions={{
                    hideUser: true
                }}
                // filterOptions will be auto-populated from modelFilters config
            />


        </div>
    );
};

export default MyBorrowingsPage;
